playlistUpdatedItem